import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ProfileService {

  // NEW: holds a picked photo until Update is clicked on the info form
  pendingPhotoFile: File | null = null;

  // NEW: lets profile.component.ts know when user-info.component.ts saved,
  // so the left card can refresh name + photo without a page reload
  private userUpdatedSource = new Subject<any>();
  userUpdated$ = this.userUpdatedSource.asObservable();

  constructor(private _http: HttpClient) { }

  getUseretails(id) {
    return this._http.get<any>(`${environment.apiBase}/user/get/${id}`);
  }

  updateUser(payload, id): Observable<any> {
    return this._http.put<any>(environment.apiBase + '/user/update/' + id, payload);
  }

  // CHANGED: now sends multipart/form-data (JSON "data" part + optional "file" part)
  // instead of a plain JSON put, to match the backend @RequestPart signature
  updateUserProfile(payload: any, id: any): Observable<any> {
  return this._http.put<any>(environment.apiBase + '/user/userprofile/' + id, payload);
}

  // NEW
  notifyUserUpdated(user: any) {
    this.userUpdatedSource.next(user);
  }
}